module.exports = __webpack_public_path__ + "static/img/CO.429d7aaf.png";